// src/data/phoneticsGlossary.js

export const PHONETICS_GLOSSARY = {
  dental: {
    title: "Dental",
    body: "Tongue touches the teeth (slightly forward). Norwegian /t d/ are often dental.",
    preset: "dental",
  },

  alveolar: {
    title: "Alveolar",
    body: "Tongue touches the ridge behind the teeth. English /t d/ are often alveolar.",
    preset: "alveolar",
  },

  fricative: {
    title: "Fricative",
    body: "Air is squeezed through a narrow gap → friction noise (like s, f, v).",
    preset: "fricative",
  },

  // UK/US spelling aliases
  velarised: {
    title: "Velarised (dark)",
    body: "Back of tongue moves toward soft palate → darker sound (like English ‘dark L’ in ball).",
    preset: "velarized",
  },
  velarized: {
    title: "Velarized (dark)",
    body: "Back of tongue moves toward soft palate → darker sound (like English ‘dark L’ in ball).",
    preset: "velarized",
  },

  palatalized: {
    title: "Palatalized",
    body: "Tongue body raises toward the hard palate, adding a slight ‘y’ color.",
    preset: "palatalized",
  },
  palatalised: {
    title: "Palatalised",
    body: "Tongue body raises toward the hard palate, adding a slight ‘y’ color.",
    preset: "palatalized",
  },

  aspirated: {
    title: "Aspirated",
    body: "Extra puff of air after a stop (like English ‘p’ in pin).",
    preset: "aspirated",
  },

  // noun form often appears in comments
  aspiration: {
    title: "Aspiration",
    body: "A puff of air after a stop. Some languages have less aspiration than Norwegian/English.",
    preset: "aspirated",
  },

  // noun form often appears in comments
  palatalization: {
    title: "Palatalization",
    body: "Palatalization: the middle of the tongue is raised toward the hard palate while the consonant is produced, giving the sound a lighter quality."
,
    preset: "palatalized",
  },

  approximant: {
    title: "Approximant",
    body: "Articulators come close but don’t create friction. Norwegian /ʋ/ is often approximant-like.",
    preset: "approximant",
  },
  "approximant-like": {
    title: "Approximant-like",
    body: "Close to an approximant: soft constriction, little/no friction noise.",
    preset: "approximant",
  },
};

export const GLOSSARY_KEYS = Object.keys(PHONETICS_GLOSSARY).sort(
  (a, b) => b.length - a.length
);
